import { UseWeightClassesListQueryParams } from './queries';
import { useMutation } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useAsyncWeightClassesListQuery() {
  return useMutation({
    mutationFn: async (params?: UseWeightClassesListQueryParams) => {
      const { data } = await SSF.api.weightClassesList(params);
      return data;
    },
  });
}
